import { useState, useRef, useEffect } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { useNavigate } from 'react-router-dom';
import { Button, Modal } from 'rsuite';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSalesById, getSalesOrder, getUserRole } from '../../redux/selector';
import Attachments from '../sharedChild/attachment/attachments';
import Email from '../sharedChild/email/emails';
import Timeline from '../sharedChild/timeline';
import Notes from '../sharedChild/note/notes';
import {
  fetchDetailAndAppendToModule,
  fetchNotesAndAppendToModule,
  fetchSalesOrderedItemAndAppendToModule,
} from '../../redux/actions';
import SalesForm from './salesForm';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import Loader from '../../shared/component/Loader';
import { toast } from 'react-toastify';
import apiServices from '../../services/service';
import EmailPopUp from '../sharedChild/emailPopUp';

export const ViewSales = () => {
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'salesOrder');
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedNote, setSelectedNote] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  const navigate = useNavigate();
  const [refreshView, setRefreshView] = useState(false);
  const salesOrderList = useSelector(getSalesOrder);
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(storeLoading);
  const userRole = useSelector(getUserRole);
  const role = userRole || '';
  const isSystemManager = role === 'System Manager';

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };

  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  function toTitleCaseFromCamel(str) {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2') // inserts space before capital letters
      .replace(/^./, (char) => char.toUpperCase()); // capitalize the first letter
  }

  const handleEditSalesOrder = () => {
    navigate(`/sales/editSalesOrder?id=${id}`, {
      state: formData,
    });
  };

  //   const sendEmailForQuote = async () => {
  //   try {
  //     const response = await apiServices.sendEmailForQuotePdf(quoteLocalData);

  //     if (response.status === 200 && response.data === 'Email Sent Successfully') {
  //       toast.success(response.data); // Show success toast
  //     } else {
  //       toast.error('Failed to send email.'); // Optional: show error toast
  //       console.error('Failed to send email:', response);
  //     }
  //   } catch (error) {
  //     toast.error('An error occurred while sending email.');
  //     console.error('Error sending quote email:', error);
  //   }
  // };

  const sendEmail = async () => {
    try {
      const cleanedData = {
        ...salesLocalData,
        saleOrderDetails:
          salesLocalData.saleOrderDetails?.map(
            ({ createdDateTime, updatedDateTime, ...rest }) => rest
          ) || [],
      };
      // Remove startDate if it's null
      if (cleanedData.dueDate == null) {
        delete cleanedData.dueDate;
      }

      // Remove endDate if it's null
      if (cleanedData.orderDate == null) {
        delete cleanedData.orderDate;
      }

      const response = await apiServices.sendEmailForSalesOrderPdf(cleanedData);

      if (response.status === 200 && response.data?.toLowerCase() === 'email sent successfully') {
        toast.success(response.data); // Show success toast
      } else {
        toast.error('Failed to send email.'); // Optional: show error toast
        console.error('Failed to send email:', response);
      }
    } catch (error) {
      toast.error('An error occurred while sending email.');
      console.error('Error sending quote email:', error);
    }
  };

  const downloadPdf = async () => {
    setLoading(true)
    try {
      // Prepare data to send (clean up if necessary)
      const cleanedData = {
        ...salesLocalData,
        saleOrderDetails:
          salesLocalData.saleOrderDetails?.map(
            ({ createdDateTime, updatedDateTime, ...rest }) => rest
          ) || [],
      };
      delete cleanedData.notesList;
      delete cleanedData.createdDateTime;
      delete cleanedData.updatedDateTime;

      // Make API call with responseType: 'blob'
      const response = await apiServices.getSalesOrderPdf(cleanedData);

      if (response.status === 200 && response.data instanceof Blob) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = `${salesLocalData?.code}.pdf`; // ✅ dynamic name with .pdf
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setLoading(false)
      } else {
        console.error('Failed to download PDF', response);
        toast.error('Failed to download PDF', { position: 'top-right' });
        setLoading(false)
      }
    } catch (error) {
      console.error('Error downloading PDF:', error);
      toast.error('An unexpected error occurred while downloading PDF.', { position: 'top-right' });
      setLoading(false)
    }
  };

  const handleClickDelete = () => {
    setDeletePopup(false); // Close the modal after deletion
  };
  const [salesLocalData, setSalesLocalData] = useState({
    ...(location.state || {}),
    type: 'view',
    from: 'view',
  });
  const salesStoreData = useSelector((state) => {
    const salesId = location.state?.id || id;
    return getSalesById(state, salesId);
  });
  console.log('salesStoreData===========================>>>>>>>>>>>>>>>>>>>', salesStoreData);

  useEffect(() => {
    setSalesLocalData((prev) => ({ ...prev, ...salesStoreData }));
  }, [salesStoreData]);

  useEffect(() => {
    const salesId = location.state?.id || id;
    if (location.pathname.includes('viewSalesOrder')) {
      setFormData({
        ...salesLocalData,
        type: 'view',
        from: 'view',
      });
    }
    if (salesId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'SaleOrder',
          id: salesId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'SaleOrder',
          id: salesId,
        })
      );
      dispatch(
        fetchSalesOrderedItemAndAppendToModule({
          moduleName: 'SaleOrder',
          id: salesId,
        })
      );
    }
  }, [location, salesLocalData?.id, refreshView]);

  const handleClickOpenConvert = () => {
    navigate('/sales/createInvoice', {
      state: {
        ...salesLocalData,
        invoiceOwner: salesLocalData?.salesOwner,
        invoiceOwnerId: salesLocalData?.salesOwnerId,
        invoiceDetails: salesLocalData?.saleOrderDetails,
        currencyPrice: salesLocalData?.currency,
        salesOrderId: salesLocalData?.id,
        salesOrder: salesLocalData?.subject,
        from: 'QuoteView',
      },
    });
  };

  const isDisabled =
    salesLocalData?.status &&
    ['delivered', 'cancelled'].includes(salesLocalData.status.toLowerCase()) &&
    !isSystemManager;

  const isLocked =
    salesLocalData?.status &&
    ['delivered', 'cancelled'].includes(salesLocalData.status.toLowerCase());

  return (
    <>
      {loading && <Loader />}
      <div id="viewsales">
        <div className="viewPageOuter">
          <div className="viewHeader">
            <HeaderProfileBlock moduleName={'Sales'} View={true} localData={formData} />
            <div className="rightAction">
              {isLocked && (
                <i
                  class="bi bi-lock-fill"
                  title="This Sales Order is locked and cannot be edited due to its finalized status"
                  style={{ color: '#3a5afe' }}
                ></i>
              )}
              <button className="btn btn-outline-primary" onClick={handleClickOpenConvert}>
                Convert To Invoice
              </button>
              <button
                className={`btn btn-outline-primary ${isDisabled ? 'disabled' : ''}`}
                onClick={handleEditSalesOrder}
                disabled={isDisabled}
              >
                Edit
              </button>
              {/* <button className="btn btn-primary" onClick={sendEmail}>Send Email</button> */}
              <div id="sendmail">
                <EmailPopUp localData={salesLocalData} module={'SalesOrder'} />
              </div>
              <button
                className="btn btn-primary d-flex align-items-center"
                onClick={downloadPdf}
                disabled={loading} // disable when loading
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Downloading...
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="currentColor"
                      className="bi bi-download"
                      viewBox="0 0 16 16"
                      style={{ marginRight: '6px' }}
                    >
                      <path d="M.5 9.9a.5.5 0 0 1 .5.6v3.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10.5a.5.5 0 0 1 1 0v3.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10.5a.5.5 0 0 1 .5-.6zm7.5-9a.5.5 0 0 1 .5.5v8.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V1.5a.5.5 0 0 1 .5-.5z" />
                    </svg>
                    Download PDF
                  </>
                )}
              </button>
            </div>
          </div>

          <div className="detailContainer">
            <div className="viewFormContainer">
              <div className="leftBlock">
                <ul>
                  {Object.keys(refs).map((key) => (
                    <li
                      key={key}
                      onClick={() => scrollToSection(key)}
                      style={{ cursor: 'pointer' }}
                      className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                    >
                      <button onClick={() => setActiveTab(key)}>{toTitleCaseFromCamel(key)}</button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rightBlock" id="detailPageRight">
                <div className="addlead_container">
                  <div id="overview" className="scrollTo" ref={refs.overview}></div>
                  <SalesForm formData={salesLocalData} />
                </div>
                <div className="tab-content">
                  <div>
                    <div>
                      <div>
                        <div></div>
                      </div>
                    </div>

                    <div id="attachments" className="scrollTo" ref={refs.attachments}></div>
                    <Attachments localData={salesLocalData} module={'SaleOrder'} />
                    <div id="emails" className="scrollTo" ref={refs.emails}></div>
                    <Email localData={salesLocalData} module={'SaleOrder'} />
                  </div>
                  <div id="timeline" className="scrollTo" ref={refs.timeline}></div>
                  <Timeline localData={salesLocalData} module={'SaleOrder'} />
                </div>
              </div>
            </div>
            <div className="viewFormNotesOuter">
              <div className="ViewFormNotesContainer">
                <Notes leadLocalData={salesLocalData} module={'SaleOrder'} />
              </div>
            </div>
          </div>
        </div>

        {deletePopup && (
          <Modal show={deletePopup} onHide={() => setDeletePopup(false)} className="modal-delete">
            <Modal.Header closeButton>
              <Modal.Title>Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete this note?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setDeletePopup(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={() => handleClickDelete(selectedNote)}>
                Confirm Delete
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ViewSales;
